(function () {
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'fio-opp-toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2400);
  }
  function add(btn) {
    var id = btn.getAttribute('data-fio-opp-add'); if (!id || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        btn.classList.remove('is-busy');
        if (drawer && data.sections && drawer.renderContents) {
          var item = data.items && data.items[0] ? data.items[0] : {};
          item.sections = data.sections; drawer.renderContents(item);
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else { toast('Adicionado à sacola'); }
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        toast((err && err.description) || 'Não foi possível adicionar. Tente de novo.');
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fio-opp-add]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation(); add(btn);
  });

  function init(root) {
    var grid = root.querySelector('[data-grid]'); if (!grid) return;
    var per = parseInt(root.getAttribute('data-page'), 10) || 24, shown = per;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.fio-opp-card'));
    var mode = root.getAttribute('data-sort');
    if (mode === 'achadinhos' || mode === 'ultimas') cards.sort(function (a, b) {
      return mode === 'achadinhos' ? (+a.dataset.price - +b.dataset.price) : (+a.dataset.stock - +b.dataset.stock);
    }).forEach(function (c) { grid.appendChild(c); });
    var seenT = {};
    root.querySelectorAll('[data-dedupe]').forEach(function (b) { var v = b.dataset.v; if (seenT[v]) b.remove(); else seenT[v] = 1; });
    var groups = null;
    if (root.getAttribute('data-group-model') === '1') {
      var STOP = 'BIQUINI BODY MAIO CALCA SAIA MINI SHORTS SHORT CAMISA CAMISETA CROPPED REGATA TOP LEGGING FITNESS MACACAO MACAQUINHO SAIDA DE DA DO PRAIA VESTIDO CONJUNTO KIT CALCINHA SUTIA BLUSA JAQUETA BERMUDA HOTPANTS HOT PANTS TOMARA QUE CAIA CORTININHA COM ARO ASA DELTA LONGA LONGO CURTA CURTO ALFAIATARIA TIRA TIRAS FRENTE UNICA'.split(' ');
      var norm = function (w) { return w.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase(); };
      var perG = parseInt(root.getAttribute('data-per-group'), 10) || 20, minG = parseInt(root.getAttribute('data-min-group'), 10) || 3;
      var map = {}, order = [];
      cards.forEach(function (c) {
        var words = (c.dataset.title || '').trim().split(/\s+/), m = '';
        for (var i = 0; i < words.length; i++) { var n = norm(words[i]); if (n && STOP.indexOf(n) < 0 && !/^\d/.test(n)) { m = n; break; } }
        if (!m) m = '_'; var sub = words.map(norm).filter(function (w) { return w === 'FLARE' || w === 'SLIM'; })[0]; if (m !== '_' && sub) m = m + ' ' + sub;
        if (!map[m]) { map[m] = []; order.push(m); }
        map[m].push(c);
      });
      var rest = [];
      var keep = order.filter(function (m) { if (m === '_' || map[m].length < minG) { rest = rest.concat(map[m]); return false; } return true; });
      var pretty = function (m) { return m.charAt(0) + m.slice(1).toLowerCase(); };
      var defs = keep.map(function (m) { return { name: pretty(map[m][0].dataset.title.split(/\s+/).filter(function (w) { return norm(w) === m; })[0] || m), cards: map[m] }; });
      if (rest.length) defs.push({ name: 'Outras peças', cards: rest });
      if (defs.length > 1) {
        var wrap = document.createElement('div'); wrap.className = 'fio-grps';
        groups = defs.map(function (d) {
          var el = document.createElement('section'); el.className = 'fio-grp';
          var nm = (d.name.charAt(0).toUpperCase() + d.name.slice(1).toLowerCase()).replace(/ (flare|slim)$/, function (s, w) { return ' ' + w.charAt(0).toUpperCase() + w.slice(1); });
          el.innerHTML = '<div class="fio-grp__head"><h2 class="fio-grp__title">' + nm + '</h2><span class="fio-label fio-grp__n"></span></div>';
          var g = document.createElement('div'); g.className = grid.className; g.removeAttribute('data-grid');
          d.cards.forEach(function (c) { g.appendChild(c); });
          var mb = document.createElement('div'); mb.className = 'fio-grp__more';
          var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'button button--secondary fio-btn'; mb.appendChild(btn);
          el.appendChild(g); el.appendChild(mb); wrap.appendChild(el);
          var o = { el: el, name: nm, cards: d.cards, shown: perG, per: perG, btn: btn, n: el.querySelector('.fio-grp__n') };
          btn.addEventListener('click', function () { o.shown += perG; apply(); });
          return o;
        });
        grid.parentNode.insertBefore(wrap, grid); grid.hidden = true;
      }
    }
    var st = { size: '', type: '', price: '' };
    var countEl = root.querySelector('[data-count]'), empty = root.querySelector('[data-empty]'), more = root.querySelector('[data-more]');
    function band(c) { var p = c / 100; return p < 100 ? '0' : (p <= 200 ? '1' : '2'); }
    function apply() {
      var ok = function (c) {
        return (!st.size || c.dataset.sizes.indexOf('|' + st.size + '|') > -1) && (!st.type || c.dataset.type === st.type) && (!st.price || band(+c.dataset.price) === st.price);
      };
      var vis = cards.filter(ok);
      cards.forEach(function (c) { c.hidden = true; });
      if (groups) {
        groups.forEach(function (g) {
          var gv = g.cards.filter(ok);
          gv.forEach(function (c, i) { c.hidden = i >= g.shown; });
          g.el.hidden = gv.length === 0;
          g.n.textContent = gv.length + (gv.length === 1 ? ' peça' : ' peças');
          var r = gv.length - g.shown;
          g.btn.parentNode.hidden = r <= 0;
          g.btn.textContent = 'Ver mais ' + g.name;
        });
      } else {
        vis.forEach(function (c, i) { c.hidden = i >= shown; });
      }
      cards.forEach(function (c) { c.querySelectorAll('.fio-size').forEach(function (b) { b.classList.toggle('is-sel', !!st.size && b.dataset.size === st.size && !b.disabled); }); });
      if (countEl) countEl.textContent = vis.length + (vis.length === 1 ? ' peça' : ' peças') + (st.size ? ' no ' + st.size : '');
      if (empty) empty.hidden = vis.length > 0;
      if (more) { var noMore = groups ? true : (vis.length - shown <= 0); more.hidden = noMore; more.parentNode.hidden = noMore; more.style.display = more.parentNode.style.display = noMore ? 'none' : ''; more.textContent = 'Ver mais'; }
      
    }
    root.querySelectorAll('[data-group]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]'); if (!b) return;
        var k = g.dataset.group, v = b.dataset.v;
        st[k] = (st[k] === v) ? '' : v;
        g.querySelectorAll('[data-v]').forEach(function (x) { x.classList.toggle('is-on', x.dataset.v === st[k]); });
        shown = per; if (groups) groups.forEach(function (g) { g.shown = g.per; }); apply();
      });
    });
    if (more) more.addEventListener('click', function () { shown += per; apply(); });
    var clear = root.querySelector('[data-clear]');
    if (clear) clear.addEventListener('click', function () {
      st = { size: '', type: '', price: '' }; shown = per; if (groups) groups.forEach(function (g) { g.shown = g.per; });
      root.querySelectorAll('[data-group] [data-v]').forEach(function (x) { x.classList.toggle('is-on', x.dataset.v === ''); });
      apply();
    });
    apply();
  }
  function boot() { document.querySelectorAll('[data-fio-opp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
